/** @typedef {import('firebase/app').FirebaseOptions} FirebaseOptions */

/**
 * Public Firebase Web project settings (not secrets).
 * Client .env only supplies REACT_APP_FIREBASE_APP_ID and REACT_APP_FIREBASE_VAPID_KEY.
 */
export const FIREBASE_WEB_PROJECT = {
    apiKey: 'AIzaSyACggrWSZqVprG0ZcpxsNBoCR7rkQC9mdI',
    authDomain: 'vectorstudents-5dab5.firebaseapp.com',
    projectId: 'vectorstudents-5dab5',
    storageBucket: 'vectorstudents-5dab5.firebasestorage.app',
    messagingSenderId: '565127971413'
};

/**
 * @returns {{ firebaseOptions: FirebaseOptions, vapidKey: string }}
 */
export function buildFirebaseConfigFromEnv() {
    return {
        firebaseOptions: {
            ...FIREBASE_WEB_PROJECT,
            appId: process.env.REACT_APP_FIREBASE_APP_ID || ''
        },
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || ''
    };
}

/**
 * @param {{ appId?: string, vapidKey?: string }} serverConfig
 * @returns {{ firebaseOptions: FirebaseOptions, vapidKey: string }}
 */
export function buildFirebaseConfigFromServer(serverConfig) {
    return {
        firebaseOptions: {
            ...FIREBASE_WEB_PROJECT,
            appId: serverConfig?.appId || ''
        },
        vapidKey: serverConfig?.vapidKey || ''
    };
}

/**
 * @param {{ firebaseOptions: FirebaseOptions, vapidKey: string }} config
 * @returns {boolean}
 */
export function isFirebaseConfigReady({ firebaseOptions, vapidKey }) {
    return Boolean(firebaseOptions.appId && vapidKey);
}
